import { ShieldAlert } from "lucide-react";

/**
 * Shown in place of a tool surface when the admin lacks `CPOS-Developers`.
 *
 * The sidebar hides these routes, so this covers direct navigation — a
 * bookmark, a shared link, or a browser history entry.
 */
export function DevelopersOnlyCard({ what = "This tool" }: { what?: string }) {
  return (
    <div className="border-border bg-card mx-auto mt-12 max-w-md rounded-lg border p-6 text-center">
      <ShieldAlert className="text-subtle-foreground mx-auto h-8 w-8" />
      <h1 className="text-foreground mt-3 text-base font-semibold">
        Developers only
      </h1>
      <p className="text-muted-foreground mt-1 text-sm">
        {what} requires the CPOS-Developers Cognito group.
      </p>
    </div>
  );
}
